import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { getErrorMessage } from '@helpers/getErrorMessage';
import { EcuationFragment } from '@modelos/analite/ecuationFragment';
import { ConfigService } from '@servicios/config.service';
import { ColDef, GridApi, GridReadyEvent, RowDoubleClickedEvent } from 'ag-grid-community';
import { getRowStyle } from 'app/_sharedFuctions/shared-functions';
import { _themeMaterial, singleRow } from '@agGridCellRender/agGrid.configs';

@Component({
    selector: 'app-assay-analite-ecuation-fragments',
    templateUrl: './assay-analite-ecuation-fragments.component.html',
    styleUrls: ['./assay-analite-ecuation-fragments.component.css'],
    standalone: false
})
export class AssayAnaliteEcuationFragmentsComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private fb: FormBuilder,
    private configService: ConfigService,
    private dialogRef: MatDialogRef<AssayAnaliteEcuationFragmentsComponent>
  ) {}

  getErrorMessage =getErrorMessage
  isEditing = false
  editingIndex: number
  /*AG Grid */
  gridApi: GridApi
  getRowStyle = getRowStyle
  rowsSelected: {name: string, value: string}[]

  rowSelection = singleRow;
  theme = _themeMaterial

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit()
  }

  onSelectionChanged() {
    this.rowsSelected = this.gridApi.getSelectedRows();
  };

  startEditRow($event: RowDoubleClickedEvent){
    this.isEditing = true
    this.editingIndex = $event.rowIndex
    this.patchFormValues($event.data)
  }

  editEcuation(data: {name:string, value:string}[], editingIndex: number, newValue: {name:string, value:string}){
    data[editingIndex] = newValue
    this.tableData = [...data]
    this.form.reset()
    this.isEditing = false
    this.deselectRows()
  }
  
  cancelEditEcuation(){
    this.editingIndex = undefined
    this.form.reset()
    this.isEditing = false
    this.deselectRows()
  }

  deselectRows() {
    this.rowsSelected = []
    this.gridApi.deselectAll()
  }

  autoSizeAll() {
    if (!this.gridApi) return
    const allColumnIds = [];
    let columns = this.gridApi.getColumns()
    if (!columns || !columns.length) return null
    columns.forEach((column) => {
      allColumnIds.push(column.getColId());
    });
    this.gridApi.autoSizeColumns(allColumnIds);
  }

  columnDefs: ColDef[] = [
    { headerName: this.configService.selectedLanguage.name, field: 'name', width: 100,suppressSizeToFit: false },
    { headerName: this.configService.selectedLanguage.value, field: 'value', width: 200, suppressSizeToFit: false},
  ];

  tableData: {name: string, value:string}[] = []

  form: FormGroup<{ name: FormControl<string>; value: FormControl<string>; }>
  importReferenceOptions = this.dialogData?.importReferenceOptions
  ngOnInit(): void {

    this.form = this.fb.group({
                      name: ["", [Validators.required, checkValueExistsInTable(this.tableData)]],
                      value: ["", [Validators.required, checkEcuationValidity()]]
                    })

    this.tableData = this.dialogData.fragments ? this.dialogData.fragments : []
                    
  }

  patchFormValues(data: {name: string, value: string}){
    this.form.get('name').patchValue(data.name)
    this.form.get('value').patchValue(data.value)
  }

  disableAddLimitButton(){
    return this.form.invalid
  }
  disableRemoveLimitButton(){
    return !this.rowsSelected?.length
  }
  addEcuation(){
    this.tableData.push({name: this.form.get('name').value, value: this.form.get('value').value})
    this.tableData = [...this.tableData]
    this.form.reset()
  }
  removeEcuation(){
    let selectedEcuation = this.rowsSelected[0]
    let removedList = this.tableData.filter(data=> data.name !== selectedEcuation.name)
    this.tableData = [...removedList]
  }

  closeDialog(){
    this.dialogRef.close()
  }

  saveChanges(){
    this.dialogRef.close(this.tableData)
  }


    /* Ecuation context menu */

    contextMenuPosition = {x: '0px', y: '0px'}

    contextMenu : MatMenuTrigger
    @ViewChild(MatMenuTrigger) set trigger (trigger: MatMenuTrigger) {
      if(trigger) this.contextMenu = trigger
    }
  
    ecuationInput : ElementRef
    @ViewChild("_ecuationInput") set input (input: ElementRef) {
      if(input) this.ecuationInput = input
    }
  
    getCursor(input: ElementRef): [number, number] {
      let start = input.nativeElement.selectionStart |0
      let end = input.nativeElement.selectionEnd | 0
      return [start, end]
    }
  
    cursor: [number, number] = [0,0]
    ecuationInputContextMenu(event: MouseEvent){
      event.preventDefault()
      this.cursor = this.getCursor(this.ecuationInput)
      this.contextMenuPosition.x = event.clientX + 'px'
      this.contextMenuPosition.y = event.clientY + 'px'
      if(this.contextMenu) this.contextMenu.openMenu();
    }
  
    insertVariable (input: ElementRef, variable: string, cursor: [number, number]) {
      let currentValue = input.nativeElement.value
      let patchedValue = currentValue.substr(0,cursor[0]) + `{I_${variable}}` + currentValue.substr(cursor[1])
      this.form.controls.value.patchValue(patchedValue)
    }
  
    checkEcuationValidity(ecuationValue: string){
      let Ecuation = new EcuationFragment(ecuationValue)
      Ecuation.processEcuation()
    }



}

export function checkValueExistsInTable(tableValues:{name: string, value:string}[]): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {

      const value = control.value;

      if (!value) { return null }

      const valueExists = tableValues.some(tableValue=> tableValue.name == value)

      return valueExists ? {valueExists:true}: null;
  }

}

export function checkEcuationValidity(): ValidatorFn{
  return (control:AbstractControl) : ValidationErrors | null => {

    const value = control.value;
    if (!value) { return null }
    
    const Ecuation = new EcuationFragment(value)

    const testResult = Ecuation.processEcuation(false)

    return testResult ? testResult : null;
}
}